import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";

export class StandingsRequestParams extends BaseApiRequestParams {
  competitions: Array<Number>;
  competitorId: Number;
  type: Number;
  live: Boolean;
  isPreview: Boolean;
  groupCategory: Number;
  stageNum: Number
  seasonNum: Number;
  withSeasons: Boolean;
  withSeasonsFilter: Boolean;
  context: String;

  constructor(
    competitions: Array<Number>,
    competitorId: Number,
    type: Number,
    groupCategory: Number,
    live: Boolean = false,
    isPreview: Boolean = false,
    stageNum: Number,
    seasonNum: Number,
    withSeasonsFilter: Boolean = false,
    context: String = ''
  ) {
    super('standings/');

    this.competitions = competitions;
    this.competitorId = competitorId;
    this.type = type;
    this.groupCategory = groupCategory;
    this.live = live;
    this.isPreview = isPreview;
    this.stageNum = stageNum;
    this.seasonNum = seasonNum;
    this.withSeasonsFilter = withSeasonsFilter;
    this.context = context;
  }

  get competitionsParam() {
    return this.competitions && this.competitions.length > 0 ? `&competitions=${this.competitions.toString()}` : '';
  }

  get competitorParam() {
    return this.competitorId ? `&competitor=${this.competitorId.toString()}` : '';
  }

  get typeParam() {
    return this.type ? `&type=${this.type}` : '';
  }

  get groupCategoryParam() {
    return this.groupCategory ? `&groupCategory=${this.groupCategory}` : '';
  }

  get liveParam() {
    return `&live=${this.live}`;
  }

  get previewParam() {
    return this.isPreview ? `&isPreview=${this.isPreview}` : '';
  }

  get stageNumParam() {
    return this.stageNum ? `&stageNum=${this.stageNum}` : '';
  }

  get seasonNumParam() {
    return this.seasonNum ? `&seasonNum=${this.seasonNum}` : '';
  }

  get withSeasonsFilterParam() {
    return this.withSeasonsFilter ? `&withSeasonsFilter=${this.withSeasonsFilter}` : '';
  }

  get contextParam() {
    return this.context ? `&context=${this.context}` : '';
  }


  toString(): string {
    return super.toString() + this.competitionsParam + this.competitorParam + this.typeParam + this.groupCategoryParam + this.liveParam + this.previewParam + this.stageNumParam + this.seasonNumParam + this.withSeasonsFilterParam + this.contextParam;
  }

  equals(model: StandingsRequestParams): Boolean {
    let equals = super.equals(model);

    equals &= this.competitionsParam === model.competitionsParam;
    equals &= this.competitorParam === model.competitorParam;
    equals &= this.typeParam === model.typeParam;
    equals &= this.previewParam === model.previewParam;
    equals &= this.stageNumParam === model.stageNumParam;
    equals &= this.seasonNumParam === model.seasonNumParam;
    equals &= this.withSeasonsFilterParam === model.withSeasonsFilterParam;
    equals &= this.contextParam === model.contextParam;


    return equals;
  }
}
